import React from 'react';
import { useNavigate } from 'react-router-dom';
import './QuickActions.css';

const QuickActions = ({ userRole }) => {
  const navigate = useNavigate();

  const actions = {
    owner: [
      { icon: 'fa-solid fa-plus', label: 'Post a New Job', path: '/owner/post-job' },
      { icon: 'fa-solid fa-ship', label: 'Manage Fleet', path: '/owner/my-ships' },
      { icon: 'fa-solid fa-inbox', label: 'Review Quotations', path: '/owner/my-jobs-quotations' },
      { icon: 'fa-solid fa-comments', label: 'Messages', path: '/messages' }
    ],
    'service-provider': [
      { icon: 'fa-solid fa-search', label: 'Find New Jobs', path: '/service-provider/available-jobs' },
      { icon: 'fa-solid fa-file-invoice', label: 'My Quotations', path: '/service-provider/my-offers' },
      { icon: 'fa-solid fa-briefcase', label: 'Active Contracts', path: '/service-provider/active-work' },
      { icon: 'fa-solid fa-building', label: 'Company Profile', path: '/service-provider/company-profile' }
    ]
  };

  const currentActions = actions[userRole] || actions.owner;

  return (
    <div className="qa-wrapper">
      <div className="qa-header">
        <h3 className="qa-title"><i className="fa-solid fa-bolt"></i> Shortcuts</h3>
      </div>
      <div className="qa-list">
        {currentActions.map((action, idx) => (
          <button key={idx} className="qa-btn" onClick={() => navigate(action.path)}>
            <i className={`${action.icon} qa-icon`}></i>
            <span>{action.label}</span>
            <i className="fa-solid fa-chevron-right qa-arrow"></i>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;